module.exports = __webpack_public_path__ + "static/fonts/Raleway-Regular.75b4247f.ttf";